<template>
  <div class="headerCate">
    <h1>{{ $t('marketplace.label.listCategory.title') }}</h1>

    <v-data-table 
      :headers="headers" 
      :items="categorias" 
      :header-props="{ class: 'red-header' }"
      :search="searchTerm"
      :no-data-text="$t('chart.label.notData') || 'No hay datos disponibles'"
      :footer-props="{ 'items-per-page-text': $t('label.rowsPerPage.title') }"
    >
      <!-- Sección superior de la tabla -->
      <template v-slot:top>
        <div style="margin-bottom: 50px">
          <div class="row justify-space-between mx-auto">
            <v-text-field
              :label="$t('label.search.title')"
              :placeholder="$t('label.search.text')"
              append-icon="mdi-magnify"
              dense
              outlined
              class="col-md-5"
              @input="search"
            ></v-text-field>

            <div class="btn">
              <addCategoriesMarketplace />
            </div>
          </div>
        </div>
      </template>
      
      <template v-slot:[`item.icono`]="{ item }"> 

        <img :src="item.icono"/>

      </template>
      
      <template v-slot:[`item.nombre`]="{ item }">
        <span class="custom-font">{{ item.nombre }}</span>
      </template>

      <template v-slot:[`item.nombreTipoCategoriaComercial`]="{ item }">
        <span class="custom-font">{{ item.nombreTipoCategoriaComercial }}</span>
      </template>

      <template v-slot:[`item.responsable`]="{ item }">
        <span class="custom-font">{{ item.responsable }}</span>
      </template>

      <template v-slot:[`item.correo`]="{ item }">
        <span class="custom-font">{{ item.correo }}</span>
      </template>

      <template v-slot:[`item.action`]="{ item }">
        <!-- Botón de acción para abrir el diálogo de detalles  -->
        <v-icon
          color="primary"
          size="x-large"
        ></v-icon>
        
        <div class="actions">

          <detailsCategory
            :status="item.activeDialogClient"
            :categoryProps="item"
            style="margin-left:1vh"
          />
          <v-btn
            class="btnDetails"
            icon    
            x-large
            dark
            text
            @click = "deleteCategorie(item.idCategoriaComercial)"
            style="background-color: transparent; margin-left:1vh"
          >
            <v-icon color="primary">mdi-delete</v-icon>
          </v-btn>
        </div>
      </template>

    </v-data-table>

  </div>
</template>

<script>
import addCategoriesMarketplace from "@/views/categories_marketplace/pages/add_categories_marketplace/add_categories_marketplace_page.vue";
import detailsCategory from "@/views/categories_marketplace/pages/detail_categories_marketplace/detail_marketplace_page.vue";
import  EventBus  from '@/utils/event_bus.js'; 
import { mapActions, mapGetters } from "vuex";
import i18n from '@/plugins/i18n';
import Swal from "sweetalert2";

import {
  MARKETPLACE_M,
  GET_CATEGORIES_MARKETPLACE,
  GET_MODO_MARKETPLACE,
  ACTION_GET_MODE_MARKETPLACE,
  ACTION_GET_CATEGORIES_MARKETPLACE,
  ACTION_DELETE_DELETE_CATEGORIES_MARKETPLACE,
  ACTION_GET_CATEGORIES_BENEFITS_MARKETPLACE,
} from "@/views/categories_marketplace/store/types/types.js";

export default {
  name: "listCategoriaComponent",
  components: {
    addCategoriesMarketplace,
    detailsCategory
  },

  data() {
    return {
      searchTerm: "",
      modos: [],
      id:null
    };
  },

  async mounted() {

    // id del modo
    await this.getMode();
    this.modos = this.modes || [];
    if (this.modos.length > 0) {
      this.id = this.modos[0].idModoCategoria;
      await this.getActioncategories(this.id);
    }

    EventBus.$on('reload-categories-marketplace', async () => {
      await this.reloadCategoriesMarketplace();
    });

    EventBus.$on('formMarketplace-submitted-successfully', async () => {
      await this.reloadCategoriesMarketplace();
    });

    EventBus.$on('reload-delete-marketplace', async () => {
      await this.reloadCategoriesMarketplace();
    });
  },

  methods: {

    ...mapActions({
      getMode: `${MARKETPLACE_M}${ACTION_GET_MODE_MARKETPLACE}`,
      getActioncategories: `${MARKETPLACE_M}${ACTION_GET_CATEGORIES_MARKETPLACE}`,
      deleteActionCategories: `${MARKETPLACE_M}${ACTION_DELETE_DELETE_CATEGORIES_MARKETPLACE}`,
      getActionmodos: `${MARKETPLACE_M}${ACTION_GET_CATEGORIES_BENEFITS_MARKETPLACE}`,
    }),

    async reloadCategoriesMarketplace() {
      await this.getActioncategories(this.id);
    },
    search() {
      // Actualiza el término de búsqueda
      this.searchTerm = event.target.value;
    },

    async deleteCategorie(idCategorie) {
        const result = await Swal.fire({
          title: i18n.t('label.delete.title'),
          text: i18n.t('label.delete.text'),
          icon: "question",
          showCancelButton: true,
          confirmButtonText: i18n.t('button.delete.accept'),
          cancelButtonText: i18n.t('button.delete.cancel'),
          confirmButtonColor: "#6E17A5",
        });

        if (result.isConfirmed) {
          
          this.deleteActionCategories(idCategorie);
          this.reloadCategoriesMarketplace();
          
        } else {
          Swal.fire({
            position: 'top-end',
            icon: 'info',
            title: i18n.t('label.delete.cancel'),
            showConfirmButton: false,
            timer: 2500
          });
        }
    },

  },

  computed: {

    ...mapGetters({
      modes: `${MARKETPLACE_M}${GET_MODO_MARKETPLACE}`,
      categorias: [`${MARKETPLACE_M}${GET_CATEGORIES_MARKETPLACE}`],
    }),

    headers() {
      return [
        {
          value: "icono",
          align: "center",
          sortable: false,
          class: "primary--text text-h1 text-md-h5 text-lg-h5 custom-header font-weight-medium text-subtitle-1",
        },
        {
          text: this.$t('marketplace.label.table.name'),
          value: "nombre",
          align: "center",
          sortable: false,
          class: "primary--text text-h1 text-md-h5 text-lg-h5 custom-header font-weight-medium text-subtitle-1",
        },
        {
          text: this.$t('marketplace.label.table.typeCategory'),
          value: "nombreTipoCategoriaComercial",
          align: "center",
          sortable: false,
          class: "primary--text text-h1 text-md-h5 text-lg-h5 custom-header font-weight-medium text-subtitle-1",
        },
        {
          text: this.$t('marketplace.label.table.responsible'),
          value: "responsable",
          sortable: false,
          align: "center",
          class: "primary--text text-h1 text-md-h5 text-lg-h5 custom-header font-weight-medium text-subtitle-1",
        },
        {
          text: this.$t('label.email.title'),
          value: "correo",
          align: "center",
          sortable: false,
          class: "primary--text text-h1 text-md-h5 text-lg-h5 custom-header font-weight-medium text-subtitle-1",
        },
        {
          //text: "Acciones",
          value: "action",  // Cambiado de 'action' a 'actions'
          sortable: false,
          align: "center",
          //class: "primary--text custom-header mdi-pencil text-subtitle-1",
        },
      ];
    }, 
  },
  
};
</script>

<style lang="css" scoped>

  .headerCate h1 {
    margin-bottom: 30px;
  }

  .headerCate {
    display: flex;
    gap: 40px;
    flex-direction: column;
    margin-top: 20px;
    margin-left: 20px;
  }

  .actions v-icon {
    font-size: 24px;
  }
  .custom-font {
    font-size: 20px;
  }
  /* Define los estilos (Tipo de letra) para las etiquetas h1,h2,h3,h4,h5,h6   */
  body {
    font-family: "Nunito Sans", sans-serif;
  }
  
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-family: "Amsi Pro", sans-serif;
    color: #2d0049;
    font-weight: normal;
  }
/* Estilos para el botón de eliminar */
  .btnDetails .v-icon {
    color: #6E17A5;
    margin-bottom: 19px;
  }

  /**estilo de los iconos */
  .actions{
    display:flex;
       
  }

  img{
    width: 3rem;
    height: 3rem;
    filter: grayscale(100%) brightness(50%) contrast(150%) hue-rotate(270deg);
  }

  @media screen and (max-width: 414px) {
        
        h1{
            font-size:3vh;
            margin-left:2vh
        }
    }

    @media screen and (min-width: 414px) {
        
        h1{
            font-size:4vh;
            margin-left:2vh
        }
    }
 
    @media screen and (max-width: 280px) { 

        h1{
            font-size:3vh;
            margin-left:2vh
        }
        h2{
            font-size:2vh;
        }
    } 

</style>
